import { render } from "./EditorMenuBar.vue?vue&type=template&id=aa8156c0&scoped=true"
import script from "./EditorMenuBar.vue?vue&type=script&lang=js"
export * from "./EditorMenuBar.vue?vue&type=script&lang=js"

import "./EditorMenuBar.vue?vue&type=style&index=0&id=aa8156c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_96a7004b96defd358d2378707b0c7ba6/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa8156c0"]])

export default __exports__